<template>
  <!-- To add thank-you image, showing after successful submit, add  to each field container-->
  <form @submit.prevent="submit" id="footer-form">
    <div class="footer-form">
      <div class="footer-form-header">Contact us</div>
      <div class="footer-form-text">Want to get in touch? Use the form below!</div>
      <div
        class="footer-input-container"
        :class="!$v.name.$invalid ? 'no-footer-input-shadow' : ''"
      >
        <input
          type="text"
          v-model.trim="$v.name.$model"
          class="footer-form-input"
          placeholder="Name"
          :style="$v.name.$error ? 'box-shadow: none !important; border: 2px solid #DF7B7B;' : null"
          :class="$v.name.$invalid ? '' : 'with-text'"
          maxlength="50"
          @input="delayTouch($v.name)"
        />
        <span v-if="$v.name.$error" style class="form-error">Please, enter your Name</span>
      </div>
      <!-- <VuePhoneNumberInput v-model="phoneNumber" class="footer-form-input" :only-countries="['NO', 'DK', 'SE']"/> -->
      <div
        class="footer-input-container"
        :class="!$v.phoneNumber.$invalid ? 'no-footer-input-shadow' : ''"
      >
        <vue-tel-input
          type="tel"
          v-bind="bindProps"
          v-model.trim="$v.phoneNumber.$model"
          class="footer-form-input"
          :class="$v.phoneNumber.$invalid ? '' : 'with-text'"
          :style="$v.phoneNumber.$error ? 'box-shadow: none !important; border: 2px solid #DF7B7B;' : null"
          maxlength="16"
          @input="delayTouch($v.phoneNumber)"
          :tokens="hexTokens"
        />
        <span v-if="$v.phoneNumber.$error" class="form-error">Please, enter valid Phone number</span>
      </div>
      <div
        class="footer-input-container"
        :class="!$v.email.$invalid ? 'no-footer-input-shadow' : ''"
      >
        <input
          type="text"
          maxlength="256"
          class="footer-form-input"
          @input="delayTouch($v.email)"
          placeholder="Email"
          v-model.trim="$v.email.$model"
          :class="$v.email.$invalid ? '' : 'with-text'"
          :style="$v.email.$error ? 'box-shadow: none !important; border: 2px solid #DF7B7B;' : null"
        />
        <span v-if="$v.email.$error" style class="form-error">Please, enter valid Email</span>
      </div>
      <button class="footer-form-btn" type="submit" >send</button>
      <div class="copy-right" >© OS-system, {{ new Date().getFullYear() }}</div>
      <!-- <div v-show="isFormSend" class="footer-form-send">
        <img :src="formSend" alt />
      </div> -->
    </div>
  </form>
</template>

<script src="https://code.jquery.com/jquery-3.4.1.min.js"></script>
<script>
import { formSend } from "../configs/form";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { VueTelInput } from '../components/vue-tel-input/dist/vue-tel-input.esm'
import $ from 'jquery';
import {
  required,
  maxLength,
  minLength,
  email
} from "vuelidate/lib/validators";

import axios from "axios";
import { TheMask } from "vue-the-mask";
import authHeader from './../utils/getAuthEmailHeader';


export default {
  name: "myform",
  components: {
    TheMask,
    VuePhoneNumberInput,
    VueTelInput
  },
  data() {
    return {
      phoneNumber: "",
      name: null,
      email: null,
      firstEnter: {
        name: true,
        phone: true,
        email: true,
      },
      formIsTouched: false,
      isFormSend: false,
      isValidPhoneNumber: true,
      formSend,
      test: false,
      hexTokens: {
        F: {
          pattern: /[0-9]/
        }
      },
      bindProps: {
        onlyCountries: ["SE", "NO", "DK"],
        disabledFetchingCountry: true,
        dropdownOptions: {
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: false
        },
        maxLen: 20,
        validCharactersOnly: true,
        placeholder: "Phone",
      }
    };
  },
  validations: {
    phoneNumber: {
      required,
      maxLength: maxLength(20),
      minLength: minLength(7)
    },
    email: {
      required,
      email
    },
    name: {
      required,
      maxLength: maxLength(25),
      minLength: minLength(3)
    }
  },
  methods: {
    delayTouch($v) {
      $v.$reset();
    },
    changeLocation() {
      // const local = 'http://localhost:8081/';
      // const dev = 'http://nordic-dev.os-system.com/';
      // const prod = 'https://nordic.os-system.com/';
      // if(window.location.href === local) {
      //   window.location = `${local}thank-you`;
      // } else if (window.location.href === dev) {
      //   window.location = `${dev}thank-you`;
      // } else {
      //   window.location = `${prod}thank-you`;
      // }
      window.location = `${window.location.href}thank-you`;
    },
    async submit() {
      this.firstEnter = {
        name: false,
        phone: false,
        email: false,
      };
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // const data = {
        //   name: this.name,
        //   phone: this.phoneNumber,
        //   email: this.email
        // };

        await axios.post(`${process.env.VUE_APP_API_LINK}/api/form`, {
          site: 'nordic',
          name: this.name,
          phoneNumber: this.phoneNumber,
          email: this.email,
          sendFrom: window.location.origin
        }, { headers: { ...authHeader() }});
        this.changeLocation();
        this.resetData();
        // this.showMessage();
      }
    },
    changeDialProp() {
      this.bindProps.inputOptions.showDialCode = true;
    },
    showMessage() {
      this.isFormSend = true;
      setTimeout(() => {
        this.isFormSend = false;
        this.$emit("clickReset");
        this.resetData();
      }, 2000);
    },
    resetData() {
      this.name = null;
      this.phoneNumber = "";
      this.test = false;
      this.email = null;
      // $('.vti__input').val('')
      this.$v.$reset();
    },

  },
  mounted() {
    var $vm = this;
      $('.vti__input').on('focus', function() {
        $vm.changeDialProp();
        $('.vti__dropdown').css({display: 'flex'});
        if ($('.vti__selection div').hasClass('se')) {
           $('.vti__input').val('+46')
        } else if ($('.vti__selection div').hasClass('dk')) {
           $('.vti__input').val('+45')
        } else if ($('.vti__selection div').hasClass('no')) {
           $('.vti__input').val('+47')
        };
      });
      $('.vti__dropdown').click(function() {
        $('.vti__input').focus()
      })
  },
};

</script>

<style scoped lang="scss">
.footer-form {
  width: 629px;
  height: 714px;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 0px 50px rgba(31, 120, 168, 0.5);
  border-radius: 0px 85px 0px 0px;
  margin: 170px auto 0;

  @media screen and (max-width: 1020px) {
    margin: 150px auto 0;
  }

  @media screen and (max-width: 900px) {
    width: 668px;
    margin-top: 100px;
  }

  @media screen and (max-width: 767px) {
    max-width: 440px;
    height: 609px;
    border-radius: 85px 85px 0px 0px;
    margin-top: 70px;
  }

  @media screen and (max-width: 479px) {
    box-shadow: 0px 0px 10px rgba(31, 120, 168, 0.5);
    border-radius: 30px 30px 0px 0px;
    width: 100%;
    max-width: initial;
  }
}

.footer-input-container {
  position: relative;

  @media screen and (max-width: 767px) {
    // box-shadow: 0px 5px 10px rgba(33, 37, 46, 0.05);
  }

  @media screen and (max-width: 479px) {
    height: 60px;
    width: 90%;
    margin: 0 16px 20px;
    border-radius: 50px;
    // overflow: hidden;
    box-shadow: 0px 5px 10px rgba(33, 37, 46, 0.05);
  }
}

.form-error {
  position: absolute;
  bottom: 9px;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  width: 488px;
  height: 22px;
  background: url("../assets/img/error-back.svg");
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 0 0 50px 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  z-index: 3;

  @media screen and (max-width: 767px) {
    width: 352px;
    height: 18px;
    font-size: 12px;
    line-height: 14px;
  }

  @media screen and (max-width: 479px) {
    background: #df7b7b;
    width: 100%;
    bottom: -8px;
    height: 16px;
    font-size: 10px;
    line-height: 12px;
  }
}

.with-text {
  box-shadow: none !important;
  border: 3px solid rgba(0, 0, 0, 0.05) !important;
  box-sizing: border-box;
}

.no-footer-input-shadow {
  @media screen and (max-width: 767px) {
    box-shadow: none;
  }
}

.without-text {
  box-shadow: none !important;
}

.footer-form-send {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.footer-form-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #000000;
  margin-top: 55px;
  margin-bottom: 15px;

  @media screen and (max-width: 767px) {
    font-size: 48px;
    line-height: 100%;
    margin-top: 70px;
    margin-bottom: 28px;
  }
  @media screen and (max-width: 479px) {
    margin-top: 55px;
    margin-bottom: 32px;
    font-size: 44px;
  }
}

.footer-form-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 35px;
  color: #000000;
  opacity: 0.8;
  text-align: center;
  margin-bottom: 40px;

  @media screen and (max-width: 767px) {
    line-height: 130%;
    max-width: 199px;
    margin: 0 auto 28px;
  }
  @media screen and (max-width: 479px) {
    font-size: 20px;
  }
}

.footer-form-input {
  margin: 0 auto 20px;
  width: 496px;
  height: 80px;
  background: #ffffff !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  box-shadow: 0px 5px 10px rgba(33, 37, 46, 0.15);
  border-radius: 50px;

  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #21252e;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none !important;

  @media screen and (max-width: 767px) {
    width: 360px;
    height: 60px;
  }
  @media screen and (max-width: 479px) {
    width: 100%;
    font-size: 16px;
    line-height: 19px;
  }

  &::placeholder {
    opacity: 0.5;
  }
}

.footer-form-btn {
  width: 499.77px;
  height: 80px;
  background: linear-gradient(0deg, #eeb012, #eeb012), #f5d220;
  box-shadow: 0px 10px 20px rgba(238, 176, 18, 0.12);
  border-radius: 50px;
  margin: 10px auto 59px;
  font-family: Roboto;
  font-style: normal;
  font-size: 24px;
  line-height: 28px;
  text-transform: uppercase;
  text-align: center;
  color: #ffffff;

  @media screen and (min-width: 769px) {
    &:hover {
      background: #f5d220;
      box-shadow: 0px 10px 20px rgba(238, 176, 18, 0.12);
    }

    &:active {
      background: #e3bf09;
      box-shadow: 0px 10px 20px rgba(238, 176, 18, 0.12);
    }
  }

  @media screen and (max-width: 767px) {
    width: 360px;
    height: 60px;
    margin-top: 0;
    margin-bottom: 40px;
    font-weight: normal;
    font-size: 20px;
    line-height: 23px;
  }

  @media screen and (max-width: 479px) {
    width: 90%;
    font-size: 18px;
    line-height: 21px;
  }
}

.copy-right {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: center;
  color: #000000;
}

</style>

<style lang="scss">
  // .tel-input-placeholder {
  //   position: absolute;
  //   top: 41%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   font-family: Roboto;
  //   font-style: normal;
  //   font-weight: normal;
  //   font-size: 18px;
  //   line-height: 21px;
  //   color: #21252e;
  //   opacity: 0.5;
  // }

  #app .vue-tel-input {
    outline: none;
    border: none;
    outline-offset: 0;
    border: 1px solid rgba(0, 0, 0, 0.05);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-box-shadow: 0px 5px 10px rgba(33, 37, 46, 0.15);
    box-shadow: 0px 5px 10px
    rgba(33, 37, 46, 0.15);
    position: relative;

    &:focus {
      box-shadow:none;
      -webkit-box-shadow: none;
    }
  }

  #app .vti__dropdown {
    display: none;
    padding: 0;
    width: 94px;
    height: 100%;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    position: absolute;
    z-index: 2;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);


    @media screen and (max-width: 769px) {
      width: 70px;
    }

  }

  #app .vti__dropdown.open {
    z-index: 4
  }

  #app .vti__dropdown::after {
    content: '';
    width: 2px;
    height: 70%;
    margin: auto;
    background-color:#F2F2F2;
    position: absolute;
    right: 0;
  }

  #app .vti__selection {
    justify-content: center;

    span {
      display: none;
    }
  }

  #app .vti__input {
    width: 100%;
    margin: auto;
    outline: none !important;
    border: none !important;
    padding-left: 0;
    text-align: center;
    border-radius: 50px;

    &:focus, &:active {
      color: black;
    }
    &::placeholder {
      opacity: 0.5
    }
  }

  #app .vti__dropdown-list {
    z-index: 4;
    width: 100%;
    top: -2px;
    left: -5px;
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    border: 3px solid rgba(0, 0, 0, 0.05);
    max-height: none;
    overflow-y: hidden;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);

    strong, span {
      display: none;
    }

    &:focus {
      box-shadow:none;
      -webkit-box-shadow: none;
    }

    @media screen and (max-width: 767px) {
        border-top-left-radius: 35px;
    }
  }

  #app .vti__dropdown-item {
    height: 77px;
    padding: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: #D4EFFF;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);
    z-index: 4;
    &:hover {
      background-color: #fff;
    }


    @media screen and (max-width: 769px) {
     height: 59px;
    }
  }

  #app .vti__dropdown-item.highlighted {
      background-color: #ffffff;
  }

  #app .vti__flag {
    background-image: url('../assets/img/norway-flag.svg');
    background-position: center;
    width: 31px;
    height: 21.5px;
    background-size: cover;
    background-color: transparent;

    @media screen and (max-width: 769px) {
      width: 25px;
      height: 15.5px;
    }
  }

  #app .vti__flag.se {
    background-image: url('../assets/img/sweeden-flag.svg');
    background-position: center;
    width: 31px;
    height: 21.5px;
    background-size: cover;
    background-color: transparent;
    box-shadow: none;

    @media screen and (max-width: 769px) {
      width: 25px;
      height: 15.5px;
    }
  }

  #app .vti__flag.no {
    background-image: url('../assets/img/norway-flag.svg');
    background-position: center;
    width: 31px;
    height: 21.5px;
    background-size: cover;
    background-color: transparent;
    box-shadow: none;

    @media screen and (max-width: 769px) {
      width: 25px;
      height: 15.5px;
    }
  }

  #app .vti__flag.dk {
    background-image: url('../assets/img/denmark-flag.svg');
    background-position: center;
    width: 31px;
    box-shadow: none;
    height: 21.5px;
    background-size: cover;
    background-color: transparent;

    @media screen and (max-width: 769px) {
      width: 25px;
      height: 15.5px;
    }
  }

</style>
